import { useEffect, useRef } from "react";
import { useToast } from "@chakra-ui/react";
import { userController } from "lib/user";
import { useHistory } from "react-router-dom";

/*
 * Polls for unread support messages every 30 seconds.
 * Shows a toast notification when new messages arrive.
 * Renders nothing visible — just a side-effect component.
 */
export default function SupportNotification() {
  const { getSingleRecord } = userController();
  const toast    = useToast();
  const history  = useHistory();
  const prevCount = useRef(null);

  useEffect(() => {
    const appSettings = JSON.parse(localStorage.getItem("app_settings") || "{}");
    if (appSettings.whatsapp_support_visible === false) return;

    const check = () => {
      getSingleRecord("/user/support/unread")
        .then((res) => {
          const count = res.data.count || 0;

          // Only notify when count increases
          if (prevCount.current !== null && count > prevCount.current) {
            toast({
              title: "Nuovo messaggio di assistenza",
              description: `Hai ${count} ${count !== 1 ? "messaggi non letti" : "messaggio non letto"} in Assistenza.`,
              status: "warning",
              duration: 8000,
              isClosable: true,
              position: "top-right",
              onClick: () => history.push("/user/support"),
            });
          }

          prevCount.current = count;
        })
        .catch(() => {}); // fail silently
    };

    check(); // run immediately on mount
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  return null;
}
